import httpClient from '@/http-client'
import config from '../config'

const handle = promise =>
  promise
    .then(response => response.data)
    .catch(error => Promise.reject(error.response ? error.response.data : error))

export const getCurrentShiftSummary = () =>
  handle(httpClient.get(`${config.apiPrefix}/shifts/current`))

export const closeRetailSaleShift = payload =>
  handle(httpClient.post(`${config.apiPrefix}/shifts/close`, payload))

export default { getCurrentShiftSummary, closeRetailSaleShift }
